var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"silkDiv"},[(_vm.runner.tabNo)?_c('img',{staticStyle:{"height":"45px","width":"45px"},attrs:{"tile":"","color":"white","alt":"silk","src":_vm.silkImg},on:{"error":_vm.setAltImage}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }